import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
let AvailabilityResponse = /*#__PURE__*/(() => {
  let AvailabilityResponse = class AvailabilityResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Array)], AvailabilityResponse.prototype, "free", void 0);
  __decorate([Expose(), __metadata("design:type", Array)], AvailabilityResponse.prototype, "taken", void 0);
  AvailabilityResponse = __decorate([ModelId("AvailabilityResponse") // auto-generated by generate-model-ids
  ], AvailabilityResponse);
  return AvailabilityResponse;
})();
export { AvailabilityResponse };
// check is case-insensitive, but note that returned value letters will be as saved in the database!
let UsernameAvailabilityRequest = /*#__PURE__*/(() => {
  let UsernameAvailabilityRequest = class UsernameAvailabilityRequest extends Model {
    static {
      this.Response = AvailabilityResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Array)], UsernameAvailabilityRequest.prototype, "names", void 0);
  UsernameAvailabilityRequest = __decorate([AppRequest('users', 'username-availability', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("UsernameAvailabilityRequest") // auto-generated by generate-model-ids
  ], UsernameAvailabilityRequest);
  return UsernameAvailabilityRequest;
})();
export { UsernameAvailabilityRequest };
// check is case-insensitive, but note that returned value letters will be as saved in the database!
let EmailAvailabilityRequest = /*#__PURE__*/(() => {
  let EmailAvailabilityRequest = class EmailAvailabilityRequest extends Model {
    static {
      this.Response = AvailabilityResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Array)], EmailAvailabilityRequest.prototype, "emails", void 0);
  EmailAvailabilityRequest = __decorate([AppRequest('users', 'email-availability', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("EmailAvailabilityRequest") // auto-generated by generate-model-ids
  ], EmailAvailabilityRequest);
  return EmailAvailabilityRequest;
})();
export { EmailAvailabilityRequest };